import { AccountApi, AccountsApi, AuthnApi, UserApi } from 'common/api';
import { LOGIN_ERROR_MSG } from 'common/compositions/VerifyDialog/Constants';
import { ACCOUNT_TYPE, USER_VERIFY_CODE_SCENE } from 'common/constants/Constants';
import { IAccount } from 'common/constants/Types';
import { UserAccountsApi } from 'idpBase/api';
import { TGlobalStore, TUpdateStore } from 'idpBase/store';
import { ITenant } from './constatns/Types';

class AccountManageStore {
  public readonly global: TGlobalStore;
  public updateStore: TUpdateStore<AccountManageStore>;
  public resetStore: () => void;

  public isBlockLoading = true;
  public tenantDialogVisible = false;
  public selectedTenant = {} as ITenant; // 当前选择操作的租户

  public writeOffCount = 10;
  public writeOffTimer = null as unknown as NodeJS.Timeout;
  public writeOffVisible = false;
  public isWriteOffLoading = false;

  public tenantChangeBindVisible = false;

  public tenants: ITenant[] = [];
  public annotationOverrides = {
    writeOffTimer: false,
  };

  public get personalTenant() {
    return this.tenants?.find((tenant) => m.get(tenant, 'accountType') === ACCOUNT_TYPE.PERSONAL);
  }

  public get companyTenants() {
    return m.isArray(this.tenants)
      ? this.tenants.filter((tenant) => m.get(tenant, 'accountType') === ACCOUNT_TYPE.COMPANY)
      : [];
  }

  public account = {} as IAccount;

  public init() {
    return Promise.all([
      this.global.profileStore.getWeComBindInfo(),
      // 目前前端登录设备管理模块被隐藏，该接口有时会报错，所以暂时屏蔽该接口调用
      // this.getLoginDevices(),
      this.getTenants(),
      this.getDomainConfig(),
    ]).finally(() => {
      this.updateStore({ isBlockLoading: false });
    });
  }

  // 获取当前关联的租户列表
  public getTenants() {
    return AccountsApi.getAccounts()
      .then((tenants) => {
        if (m.isArray(tenants)) this.updateStore({ tenants });
      })
      .catch((err) => {
        this.global.handleError(err);
      });
  }

  // 发送验证码
  public sendCode(event?: USER_VERIFY_CODE_SCENE, mobile?: string) {
    return UserApi.sendCode(event, mobile);
  }

  public rebindTenantSendCode(accountId: string, mobile: string) {
    return UserApi.rebindTenantSendCode(accountId, { mobile });
  }

  // 验证验证码
  public verifyCode(
    verificationCode: string,
    verificationSessionId: string,
    event?: USER_VERIFY_CODE_SCENE,
  ) {
    return UserApi.verifyMobile({
      verificationCode,
      verificationSessionId,
      event,
    });
  }

  public resetMobile() {
    return UserApi.resetMobile();
  }

  public writeOffCountDown() {
    clearTimeout(this.writeOffTimer);
    if (this.writeOffCount <= 0) return;
    this.writeOffTimer = setTimeout(() => {
      this.updateStore({ writeOffCount: this.writeOffCount - 1 });
      this.writeOffCountDown();
    }, 1000);
  }

  // 租户换绑至其他手机号
  public tenantRebind(data: {
    verificationCode: string;
    verificationSessionId: string;
    mobile: string;
  }) {
    const id = m.get(this.selectedTenant, 'id');
    return UserAccountsApi.rebindMobileOfTenant(id, data);
  }

  public changeAccount(id: string, unionId: string) {
    return AuthnApi.changeAccount(id, unionId).catch((err) => {
      const errMessage = LOGIN_ERROR_MSG[_.get(err, 'data.errCode')];
      this.global.handleError(errMessage || err);
      return Promise.reject();
    });
  }

  public getDomainConfig() {
    return AccountApi.getDomainConfig()
      .then((account) => {
        this.updateStore({ account: account || {} });
      })
      .catch((err) => {
        this.global.handleError(err);
      });
  }
}

export default AccountManageStore;
